<template>
  <div id="fszhezhao">
    <div class="tc o1rem">
      <span>{{ message }}</span>
      <img src="../../assets/jt.png">
    </div>
  </div>
</template>

<script>

export default {
  name: "fszhezhao",
  components: {},
  props: ['message'],
  data() {
    return {
    };
  },
  methods: {
  },
  mounted: function() {
    
  }
};
</script>

<style scoped>
.tc{
  background: rgba(0, 0, 0, .8);
  text-align: right;
  color: #fff;
  font-size: 16px;
}
img{
  width: 5rem;
  transform: translateY(1rem);
}
</style>
